import React, { Component } from 'react';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import {get,toNumber} from 'lodash';
import moment from 'moment';
import {storeNRWByDMA,storeSearchMonth,storeSearchYear,storeSearchDMA} from '../../../redux/general/action'

// import MyMap from '../../content/map/map/map.component';
import RealLoss from '../../page/real-loss-page/real-loss-page.component';
import WaterBalanceTable from '../../page/water-balance-table-page/water-balance-table-page.component';
import MapEsri from '../../content/map/map-esri/map-esri.component'
import './map-page.style.css'

class MapPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            // dataNRWByDMA : {},
            defaultActiveKeyTab : 'map'
        }
    }

    getDataNRWByDMAFromParent = (dataNRWByDMA) => {
        // this.setState({dataNRWByDMA : dataNRWByDMA});
        this.props.storeNRWByDMA(dataNRWByDMA? dataNRWByDMA : {});
        this.props.storeSearchMonth(dataNRWByDMA? dataNRWByDMA.MONTH : toNumber(moment(new Date()).format('MM')));
        this.props.storeSearchYear(dataNRWByDMA? dataNRWByDMA.YEAR : toNumber(moment(new Date()).format('yyyy')));
        this.props.storeSearchDMA(dataNRWByDMA? dataNRWByDMA.DMAID : '');
    }

    setDefaultActiveKeyTab = (key) => {
        this.setState({defaultActiveKeyTab: key});
    }

    render() {
        return (
            // <div>
            //     <p className="content-test">Lorem ipsum dolor sit amet, consectetur adipiscing elit. ae risus tristique posuere.</p>
            // </div>
            <div className='map-page'>
                
                <Tabs defaultActiveKey='map' id="uncontrolled-tab-example" 
                    activeKey={this.state.defaultActiveKeyTab}
                    onSelect = {(k) => this.setState({defaultActiveKeyTab:k})}>
                    <Tab eventKey="map" title="Map">
                        <MapEsri getDataNRWByDMAFromParent = {this.getDataNRWByDMAFromParent}
                            setDefaultActiveKeyTab = {this.setDefaultActiveKeyTab}></MapEsri>
                    </Tab>
                    <Tab eventKey="realloss" title="Real loss">
                        <RealLoss></RealLoss>
                    </Tab>
                    <Tab eventKey="waterbalancetable" title="Water balance">
                        <WaterBalanceTable ></WaterBalanceTable>
                    </Tab>
                </Tabs>

            </div>
        )
    }
}

const mapStateToProps = state => ({
    dataNRWByDMA: get(state, 'GeneralStore.dataNRWByDMA'),
    searchMonth: get(state,'GeneralStore.searchMonth'),
    searchYear: get(state,'GeneralStore.searchYear'),
    searchDMA: get(state,'GeneralStore.searchDMA'),
})

const mapDispatchToProps = dispatch => {
    return {
        storeNRWByDMA: dataNRWByDMA => {
        dispatch(storeNRWByDMA(dataNRWByDMA))
      },
      storeSearchMonth: searchMonth => {
        dispatch(storeSearchMonth(searchMonth))
    },
    storeSearchYear: searchYear => {
        dispatch(storeSearchYear(searchYear))
    },
    storeSearchDMA: searchDMA => {
        dispatch(storeSearchDMA(searchDMA))
    }
    }
  }

// export default MapPage
export default connect(mapStateToProps, mapDispatchToProps)(MapPage)
